export default "__VITE_ASSET__DOSJRYi1__"